<template>
  <v-dialog :value="value" max-width="800" scrollable @input="$emit('input', $event)">
    <v-card>
      <v-card-title>
        Schema JSON Preview
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto;">
        <pre class="schema-json-preview">{{ formattedJson }}</pre>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="copyToClipboard">
          <v-icon small left>mdi-content-copy</v-icon>
          Copy
        </v-btn>
        <v-btn text @click="$emit('input', false)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    formattedJson() {
      return JSON.stringify(this.schema, null, 2)
    },
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.formattedJson).catch(() => {})
    },
  },
}
</script>

<style scoped>
.schema-json-preview {
  background: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  font-size: 13px;
  overflow-x: auto;
  white-space: pre;
}
</style>
